import { getMessaging } from 'firebase/messaging/sw';
import { getToken } from 'firebase/messaging';
import { getApp } from 'firebase/app';
import { captureException } from '@sentry/browser';
import { getDeviceAndUserStore } from '../storage/stores';
import * as qinit from '../qinit';

/**
 * Obtain FCM token in Service Worker context
 *
 * Gets token from Firebase (initialized in messaging.ts) and stores it
 * in DeviceAndUserStore.fcm.pushToken.
 *
 * @throws Error when VAPID key is missing or token cannot be obtained
 */
export const obtainFcmToken = async (): Promise<void> => {
  try {
    const vapidKey =
      qinit.tenant.chromebook.pushNotificationConfig?.vapidKey?.key;
    if (!vapidKey) {
      throw new Error('VAPID key not found in qinit');
    }

    const firebase = getApp();
    const messaging = getMessaging(firebase);
    const token = await getToken(messaging, {
      vapidKey,
      serviceWorkerRegistration: (
        globalThis.self as unknown as {
          registration: ServiceWorkerRegistration;
        }
      ).registration,
    });

    const deviceUserStore = getDeviceAndUserStore();
    const currentFcmInfo = deviceUserStore.get()?.fcm ?? {};

    await deviceUserStore.set({
      fcm: {
        ...currentFcmInfo,
        pushToken: token,
      },
    });
  } catch (error) {
    console.error('Error obtaining FCM token:', error);
    captureException(error as Error);
    throw error;
  }
};
